import { render, staticRenderFns } from "./SwitchContaAtivaField.vue?vue&type=template&id=58d48633&scoped=true&"
import script from "./SwitchContaAtivaField.vue?vue&type=script&lang=js&"
export * from "./SwitchContaAtivaField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchContaAtivaField.vue?vue&type=style&index=0&id=58d48633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d48633",
  null
  
)

export default component.exports